import { render } from "./ResetNewPassword.vue?vue&type=template&id=75f44873"
import script from "./ResetNewPassword.vue?vue&type=script&lang=js"
export * from "./ResetNewPassword.vue?vue&type=script&lang=js"

import "./ResetNewPassword.vue?vue&type=style&index=0&id=75f44873&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__